import { Grid } from "@mui/material";
import LandingHero from "../../components/modules/listings/landingHero";
import ListingFeaturedListings from "../../components/modules/listings/listingFeaturedListings";
import { useEffect } from "react";
import { issueSuccessMessage, issueWarnMessage } from "../../actions/message";

export default function ListingLanding() {
  // Parse locationPermission and location from localStorage
  let locationPermission = null;
  let location = null;
  try {
    const stored = JSON.parse(localStorage.getItem("locationPermission"));
    if (stored) {
      locationPermission = stored.locationPermission;
      location = stored.location;
    }
  } catch (e) {
    locationPermission = null;
    location = null;
  }

  function requestLocationPermission() {
    if (!navigator.geolocation) {
      issueWarnMessage("Geolocation is not supported by your browser.");
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const loc = {
          coords: {
            lat: position.coords.latitude,
            lon: position.coords.longitude,
            accuracy: position.coords.accuracy,
          },
          timestamp: position.timestamp,
        };
        localStorage.setItem(
          "locationPermission",
          JSON.stringify({
            locationPermission: true,
            location: loc,
          }),
        );
        issueSuccessMessage("Location permission granted");
        window.location.reload(); // reload to update state
      },
      () => {
        localStorage.setItem(
          "locationPermission",
          JSON.stringify({
            locationPermission: false,
            location: null,
          }),
        );
        issueWarnMessage("Permission not granted :(");
        window.location.reload(); // reload to update state
      },
    );
  }

  useEffect(() => {
    if (locationPermission === null) {
      // Ask the user for location permission
      requestLocationPermission();
    }
  }, [locationPermission]);

  return (
    <Grid sx={{ backgroundColor: "#efefef" }} container>
      <LandingHero />
      <ListingFeaturedListings location={location?.coords} />
    </Grid>
  );
}
